import qs from 'querystring'

//	Uses lowercase for all parameter keys
const getNormalisedParameters = (searchStr) => {
	const tempParsedSearch = qs.parse(searchStr.indexOf('?') === 0 ? searchStr.substr(1) : searchStr)
	const parsedSearch = {}

	Object.keys(tempParsedSearch).forEach((key) => {
		parsedSearch[key.toLowerCase()] = tempParsedSearch[key]
	})
	return parsedSearch
}

export default getNormalisedParameters



// WEBPACK FOOTER //
// ./src/utilities/getNormalisedParameters.js